import { CreateTVGuideRequest, CreateTVGuideResponse, TVGuide } from '@/types/model';
import { apiClient, QueryParams, PaginatedResponse } from './apiClient';

export interface TVGuideQueryParams extends QueryParams {
  active?: boolean;
}

export const tvGuideService = {
  /**
   * Get TV guides with pagination, search, and filtering
   */
  async getTVGuides(params: TVGuideQueryParams = {}): Promise<PaginatedResponse<TVGuide>> {
    return apiClient.getPaginated<TVGuide>('/tv-guides', params);
  },

  /**
   * Get a single TV guide by ID
   */
  async getTVGuideById(id: string): Promise<TVGuide> {
    return apiClient.getById<TVGuide>('/tv-guides', id);
  },

  /**
   * Create a new TV guide
   */
  async createTVGuide(tvGuideData: CreateTVGuideRequest): Promise<CreateTVGuideResponse> {
    return apiClient.create<CreateTVGuideRequest, CreateTVGuideResponse>('/tv-guides', tvGuideData);
  },

  /**
   * Update a TV guide
   */
  async updateTVGuide(id: string, tvGuideData: Partial<CreateTVGuideRequest>): Promise<CreateTVGuideResponse> {
    return apiClient.update<Partial<CreateTVGuideRequest>, CreateTVGuideResponse>('/tv-guides', id, tvGuideData);
  },

  /**
   * Delete a TV guide
   */
  async deleteTVGuide(id: string): Promise<{ success: boolean; message: string }> {
    return apiClient.deleteById<{ success: boolean; message: string }>('/tv-guides', id);
  },

  /**
   * Toggle TV guide active status
   */
  async toggleTVGuideStatus(id: string, active: boolean): Promise<CreateTVGuideResponse> {
    return apiClient.toggleStatus<CreateTVGuideResponse>('/tv-guides', id, active);
  },

  /**
   * Trigger sync for a TV guide
   */
  async syncTVGuide(id: string): Promise<{ success: boolean; message: string }> {
    return apiClient.post<{ success: boolean; message: string }>(`/tv-guides/${id}/sync`);
  },
};
